const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.429688,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    fill: "url(#paint0_linear_148_1686)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7737 26.943C22.9948 28.1088 21.857 28.8906 21.5769 29.8945C21.5652 29.9362 21.5482 30.1863 21.5389 30.2283H27.4949L28.5979 32.2138H18.6698C18.4943 29.3543 19.5614 27.5486 22.8402 25.5329C24.9916 24.2096 25.6053 23.226 25.6595 22.061C25.6595 20.7392 24.6591 19.905 23.4111 19.91C22.0806 19.9152 21.03 20.891 20.7782 22.2722L19.5336 19.9705C19.9385 19.2882 20.5128 18.7221 21.2007 18.3269C21.8886 17.9317 22.6669 17.7208 23.4602 17.7146C26.3526 17.7146 28.2339 19.6136 28.2319 22.044C28.2302 23.9543 27.1959 25.355 24.7737 26.943ZM21.538 24.934H15.5815L13.596 29.1255H10.9487L17.7875 14.7864H18.2288L19.5527 16.9935L16.6845 22.9485H20.435L21.538 24.934ZM35.9106 24.2185C35.9106 27.1159 33.5719 29.497 30.2592 29.4348C28.6927 29.4334 27.1889 28.8188 26.0699 27.7226L27.7322 26.1296C28.0476 26.4847 28.4338 26.7698 28.866 26.9667C29.2981 27.1636 29.7667 27.2679 30.2416 27.2729C31.0695 27.2876 31.8696 26.9736 32.4665 26.3996C33.0634 25.8257 33.4086 25.0386 33.4264 24.2107C33.4264 22.6014 32.1205 21.2748 30.3384 21.2518C30.1167 21.2499 29.8959 21.2792 29.6825 21.3388L28.8178 19.86C28.8163 19.858 31.6258 16.693 31.6497 16.7243C31.6852 16.7717 27.2736 16.7717 27.2736 16.7717L26.1703 14.7862H34.5529V16.5512L31.8663 19.5453C34.7015 20.1264 35.9106 22.2171 35.9106 24.2185Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_1686",
    x1: 23.4297,
    y1: 0.5,
    x2: 23.4297,
    y2: 47.6866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB88D",
    style: {
      stopColor: "#CFB88D",
      stopColor: "color(display-p3 0.8118 0.7216 0.5529)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59462E",
    style: {
      stopColor: "#59462E",
      stopColor: "color(display-p3 0.3490 0.2745 0.1804)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/newLogo.b72b9d3a6b3eeac3d495a09bd5339a9e.svg";
export { ForwardRef as ReactComponent };